import { createFileRoute } from "@tanstack/react-router";
import CustomerPage from "pages/app/customer/CustomerPage";
import { z } from "zod";
import { getCustomer } from "api/customer.api";

const customerSearchSchema = z.object({
  tab: z
    .enum([
      "oversikt",
      "anlaggningar",
      "underkunder",
      "formedlade-uppdrag",
      "avfalls-statistik",
      // "kundportal",
    ])
    .optional()
    .catch("oversikt"),
});

export const Route = createFileRoute("/_authenticated/app/kunder/$customerId/")(
  {
    validateSearch: customerSearchSchema,
    beforeLoad: async ({ context: { queryClient }, params }) => {
      await queryClient.ensureQueryData(getCustomer(Number(params.customerId)));
    },
    component: CustomerPage,
  },
);
